import * as React from 'react'
import * as actions from "./actions"


const SiloContext = React.createContext()

const reducer = (state, action) => {
    switch (action.type) {
        case actions.SET_INITIAL_DATA:
            const { pageId = "", ordersList = [], userData } = action.data || {};
            let premiumUser = false, basePlanUser = false;

            ordersList.forEach((payment) => {
                if (payment.status === 'ACTIVE') {
                    let plan = payment.planName;
                    plan = (typeof plan === "string") ? plan : "";
                    plan = plan.trim();
                    premiumUser = premiumUser || plan.startsWith("Pro");
                    basePlanUser = basePlanUser || plan.startsWith("Core");
                }
            });

            return {
                ...state,
                paymentsData: {
                    minisyncUser: pageId === "minisync",
                    premiumUser,
                    basePlanUser,
                    isPaidUser: premiumUser || basePlanUser,
                    fetched: true
                },
                wixUser: userData || {}
            };

        case actions.SET_CURRENT_USER_DATA:
            const { userAccounts } = state;
            const existedAccountIndex = userAccounts.findIndex(account => account.id === action.data?.id);

            const listItem = {
                id: action.data.id,
                email: action.data.owner_email,
                display_name: action.data.display_name
            };

            if (existedAccountIndex >= 0) {
                userAccounts[existedAccountIndex] = listItem
            } else if (action.data?.id?.length > 0) {
                userAccounts.unshift(listItem);
            }

            return { ...state, userData: action.data || {}, userAccounts }

        case actions.SET_USER_ACCOUNTS:
            return { ...state, userAccounts: action.data || [] }

        case actions.DELETE_USER:
            const d_userAccounts = [...state.userAccounts];
            const index = d_userAccounts.findIndex((item) => item.id === action.data?.id)

            if (index >= 0) {
                d_userAccounts.splice(index, 1)
            }

            return { ...state, userAccounts: d_userAccounts };

        default:
            return { ...state }
    }
}

export function useSelector(selectorCallback) {
    const { state } = React.useContext(SiloContext)
    return selectorCallback(state)
}

export function useDispatch() {
    const ctx = React.useContext(SiloContext)
    return (action) => {
        ctx.dispatch(action)
    }
}

const defaultStoreState = {
    paymentsData: {
        premiumUser: false,
        basePlanUser: false,
        isPaidUser: false,
        fetched: false
    },
    userAccounts: [],
    userData: {},
    wixUser: {}
}

function SiloCtxProvider({ defaultState = {}, children }) {
    const [state, dispatch] = React.useReducer(reducer, { ...defaultStoreState, ...defaultState })

    const value = { state, dispatch }
    return <SiloContext.Provider value={value}>{children}</SiloContext.Provider>
}

export default SiloCtxProvider
